<template>
  <div class="login">
    <div class="login-con">
      <div class="login-center">
        <img alt class="login-logo" src="https://p1.ssl.qhimg.com/t01036d8e5175d30997.png" />
        <div class="login-panel">
          <p class="login-title">视图计算</p>
          <div class="login-board">
            <p class="login-board-title">360账号登录</p>
          </div>
        </div>
      </div>
    </div>
    <p class="copyright">
      Copyright©2026 360.CN All Rights Reserved 360互联网安全中心
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502062738" rel="noopener noreferrer" target="_blank">京公网安备11010502062738号</a>
      <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noopener noreferrer" target="_blank">京ICP证080047号[京ICP备08010314号-6]</a>
    </p>
  </div>
</template>

<script>
import global from "../utils/Global";
export default {
  name: "Login",
  data () {
    return {};
  },
  mounted () {
    clearInterval(global.eventTipTimer);
    global.eventTipTimer = 0;
    global.eventTipsaveNums = -1;
    global.eventTipNums = 0;
    var that = this;
    try {
      QHPass.signIn(
        $(".login-board"),
        function (e) {
          QHPass.getUserInfo(
            function (data) {
              global.userInfo = data;
              console.log("userinfo jumping", data);
              return that.$router.push("overview")
              // var to_ = that.$route.query.backto;
              // if (to_) {
              //   that.$router.push(to_);
              // } else {
              //   that.$router.push("ai");
              // }
            },
            function (err) {
              global.userInfo = null;
              console.log("userinfo error", err);
            }
          );
        },
        function (err2) {
          console.log("userinfo error2", err2);
        }
      );
    } catch (e) {
      console.log("login error", e);
    }

    $(".quc-link").each(function () {
      //   console.log($(this).attr("href"));
    });
    // $(".quc-link").attr("href", "2222");
  },
  methods: {
    login () { },
  },
};
</script>

<style lang='less' scoped>
body,
html {
  position: relative;
  width: 100%;
  height: 100%;
}
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 48px;
  background: #fff;
  .login-con {
    width: 1300px;
    height: 90%;
    max-height: 820px;
    .login-center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .login-logo {
        width: auto;
        height: 100%;
        margin: 0 auto;
        text-align: center;
      }
      .login-panel {
        width: 420px;
        margin: 0 auto;
        background: #fff;
        position: relative;
        border-radius: 8px;
        .login-title {
          width: 300px;
          margin: 0 auto 30px;
          font-size: 24px;
          font-weight: bold;
          color: #202020;
          line-height: 33px;
          &:before {
            content: '';
            display: inline-block;
            width: 3px;
            height: 20px;
            margin: 7px 10px 0 0;
            float: left;
            background: #006bff;
          }
        }
      }
    }
  }
}
.login-board {
  width: 370px;
  margin: 0 auto;
}
.copyright {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 16px;
  margin: 0;
  text-align: center;
  font-size: 12px;
  color: #999;
  line-height: 20px;
  z-index: 2;
  a {
    color: #999;
    text-decoration: none;
    &:hover {
      color: #666;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/login.vue